import React from 'react';
import Layout from '@components/Layout/Layout';
import FlowForm from '@components/Flow/FlowForm/FlowForm';

const View = ({
  data: { loading, offer, showAlert, startSetStreamOffer },
  onSubmit,
  selectedOffer,
  selectedLanding,
  selectedPreLanding,
}) => {
  return (
    <Layout>
      <Layout.Col>
        <FlowForm
          offer={offer}
          loading={loading}
          onSubmit={onSubmit}
          onOfferChange={startSetStreamOffer}
          selectedOffer={selectedOffer}
          selectedLanding={selectedLanding}
          selectedPreLanding={selectedPreLanding} 
          showAlert={showAlert}
        />
      </Layout.Col>
    </Layout>
  );
};

export default View;
